import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, className, ...props }) => {
  if (!icon) {
    // Only show alert if icon is explicitly missing/undefined in development
    // For production, we might want to render nothing or a transparent placeholder
    return <FiAlertTriangle className={`text-red-400 ${className}`} {...props} />;
  }

  // If icon is a React component (function)
  if (typeof icon === 'function') {
    return React.createElement(icon, { className, ...props });
  }

  // If icon is already an element
  if (React.isValidElement(icon)) {
    return React.cloneElement(icon, { className, ...props });
  }

  return <FiAlertTriangle className={className} {...props} />;
};

export default SafeIcon;